enum ENavigationPosition {
  SIDE = 'side',
  TOP = 'top',
}

export default ENavigationPosition;
